module.exports = __webpack_public_path__ + "static/media/image26.5dfc4ef9.jpg";